import { create } from "zustand";

interface SessionStore {
  sessions: string[];
  map: Record<string, { name: string; agent_id: string, sessions: string[] }>;
  updateStore: (sessions: [], map: Record<string, any>) => void;
}

export const useSessionStore = create<SessionStore>((set) => {
  return {
    sessions: [],
    map: {},
    updateStore(sessions, map) {
      set({ sessions, map });
    },
  }
});